import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { AppDispatch, RootState } from "../../store";
import { refreshAccessToken, syncSessionFromApi } from "../../slices/session";
import { FullPageLoading } from "../utils/Loading";

function PersistLogin() {
  const loading = useSelector((state: RootState) => state.session.loading);
  const accessToken = useSelector(
    (state: RootState) => state.session.accessToken
  );
  const refreshToken = useSelector(
    (state: RootState) => state.session.refreshToken
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        if (accessToken) {
          const r = await dispatch(syncSessionFromApi());
          if (cancelled) return;
          if (syncSessionFromApi.rejected.match(r) && refreshToken) {
            await dispatch(refreshAccessToken(refreshToken));
          }
        } else {
          await dispatch(refreshAccessToken(refreshToken));
        }
      } catch (error) {
        console.error(error);
      }
    };

    void run();
    return () => {
      cancelled = true;
    };
  }, [accessToken, refreshToken, dispatch]);

  return <>{loading ? <FullPageLoading /> : <Outlet />}</>;
}

export default PersistLogin;
